import React, { useState, useRef, useEffect } from 'react';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import {
  DialogContent,
  DialogActions,
  Avatar,
  Slider,
  FormHelperText,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'react-easy-crop'.
import Cropper from 'react-easy-crop';
import { PubSub } from '../../utils/eventUtils';
import CbButton from '../Buttons/CbButton';
import { postAgencyLogo, uploadAgencyLogoSmall } from '../../api/AuthService';

// @ts-expect-error TS(2345): Argument of type '({ config }: DefaultTheme) => { ... Remove this comment to see the full error message
const useStyles = makeStyles(({ config }) => {
  return {
    wrapper: {
      fontSize: `${config.textSizes.tertia} !important`,
      textAlign: 'left !important',
      fontWeight: 'normal !important',
      display: 'flex',
      justifyContent: 'center',
    },
    flexBox: {
      display: 'flex',
      paddingTop: '1.66rem',
      justifyContent: 'space-around',
    },
    darkTheme: {
      width: 120,
      height: 120,
      borderRadius: '5px',
      backgroundColor: config.colors.darkGreyLighter,
    },
    lightTheme: {
      width: 120,
      height: 120,
      borderRadius: '5px',
      backgroundColor: config.colors.eggWhite,
      border: `1px solid ${config.colors.darkGrey3}`,
    },
    text: {
      fontSize: config.textSizes.normal,
      paddingTop: '0.833rem',
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    avatar: {
      width: 240,
      height: 240,
    },
    negitive: {
      paddingRight: 10,
      position: 'relative',
      bottom: 3.5,
    },
    positive: {
      paddingLeft: 10,
      position: 'relative',
      bottom: 3.5,
    },
  };
});

export const UploadAgencyLogoSmall = ({ data, close }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cp, setCp] = useState({});
  const [error, setError] = useState('');
  const [pic, setPic] = useState(data.url);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const img = useRef(null);
  const cnv = useRef(null);
  const img1 = useRef(null);
  const cnv1 = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const canvas = cnv.current;
    const image = img.current;
    const canvas1 = cnv1.current;
    const image1 = img.current;

    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const ctx = canvas.getContext('2d');
    // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
    ctx.clearRect(0, 0, cp.width, cp.height);
    ctx.drawImage(
      image,
      // @ts-expect-error TS(2339): Property 'x' does not exist on type '{}'.
      cp.x,
      // @ts-expect-error TS(2339): Property 'y' does not exist on type '{}'.
      cp.y,
      // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
      cp.width,
      // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
      cp.height,
      0,
      0,
      // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
      cp.width,
      // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
      cp.height
    );

    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const ctx1 = canvas1.getContext('2d');
    // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
    ctx1.clearRect(0, 0, cp.width, cp.height);
    ctx1.drawImage(
      image1,
      // @ts-expect-error TS(2339): Property 'x' does not exist on type '{}'.
      cp.x,
      // @ts-expect-error TS(2339): Property 'y' does not exist on type '{}'.
      cp.y,
      // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
      cp.width,
      // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
      cp.height,
      0,
      0,
      // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
      cp.width,
      // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
      cp.height
    );
    // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
    // eslint-disbale-next-line
  }, [cp.height, cp.width, cp.x, cp.y]);

  const onCropChange = (cropValue: any) => {
    setCrop(cropValue);
  };

  const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
    setCp(croppedAreaPixels);
  };

  const onZoomChange = (zoomvalue: any) => {
    setZoom(zoomvalue);
  };

  const closeModal = () => {
    close();
    data.ref.current.value = '';
  };

  const selectFile = () => {
    if (fileInputRef) {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      fileInputRef.current.click();
    }
  };

  const changeImage = () => {
    const bodyFormData = new FormData();
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const file = fileInputRef.current.files[0];
    bodyFormData.append('file', file);

    const { size } = file;

    if (size / 1000 > 50) {
      setError('The file size is too big, 50kb max.');
    } else {
      setLoading(true);
      postAgencyLogo(data.id, true, bodyFormData)
        .then((resp) => {
          setLoading(false);
          setError('');
          setPic(resp.data);
        })
        .catch((error) => {
          setLoading(false);
          setError(error.response.data);
        });
    }
  };

  const onSubmit = () => {
    data.ref.current.value = '';
    setUploadLoading(true);
    const payload = {
      zoomFactor: zoom,
      // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
      width: Math.min(cp.width, img.current.width),
      // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
      height: Math.min(cp.height, img.current.height),
      logoPath: pic,
      agencyId: data.id,
      small: true,
    };
    uploadAgencyLogoSmall(
      // @ts-expect-error TS(2339): Property 'x' does not exist on type '{}'.
      { xCoordinate: cp.x < 0 ? 0 : cp.x, yCoordinate: cp.y < 0 ? 0 : cp.y },
      payload
    )
      .then(() => {
        setUploadLoading(false);
        enqueueSnackbar('Logo Uploaded Successfully!', {
          variant: 'success',
        });
        close();
        PubSub.publish('agency:uploaded', true);
      })
      .catch((error) => {
        setUploadLoading(false);
        setError(
          _.get(
            error,
            'response.data',
            'Something went wrong.Please try again!'
          )
        );
      });
  };

  const canvasStyle = {
    width: 96,
    height: 96,
  };

  return (
    <>
      <DialogContent className="modal-title">
        {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
        <div className={classes.wrapper}>
          Please select a PNG, JPG or GIF image file with size smaller than 50kb
          to upload
          <br /> and crop to be your logo.
        </div>
        {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}

        <div className={classes.flexBox}>
          <div style={{ paddingRight: '1rem' }}>
            {/* @ts-expect-error TS(2339): Property 'avatar' does not exist on */}
            <Avatar variant="square" className={classes.avatar}>
              <Cropper
                image={pic}
                crop={crop}
                zoom={zoom}
                aspect={1}
                minZoom={0.4}
                restrictPosition={false}
                cropShape="rect"
                cropSize={{ width: 144, height: 144 }}
                showGrid={false}
                onCropChange={onCropChange}
                onCropComplete={onCropComplete}
                onZoomChange={onZoomChange}
              />
            </Avatar>
            <div style={{ display: 'flex' }}>
              {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
              <span className={classes.negitive}>-</span>
              <Slider
                value={zoom}
                min={0.4}
                max={3}
                step={0.1}
                aria-labelledby="Zoom"
                // @ts-expect-error TS(2769): No overload matches this call.
                classes={{ container: classes.slider }}
                // @ts-expect-error TS(2345): Argument of type 'number | number[]' is not assign... Remove this comment to see the full error message
                onChange={(e, sliderZoom) => setZoom(sliderZoom)}
              />
              {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
              <span className={classes.positive}>+</span>
            </div>
          </div>

          <div style={{ paddingRight: '1rem' }}>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <Avatar variant="square" className={classes.darkTheme}>
              <img
                ref={img1}
                id="source"
                style={{ display: 'none' }}
                src={pic}
                alt="dark profile"
              />
              <canvas
                ref={cnv1}
                id="canvas"
                // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
                width={cp.width}
                // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
                height={cp.height}
                style={canvasStyle}
              />
            </Avatar>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <div className={classes.text}>DARK THEME</div>
          </div>

          <div>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <Avatar variant="square" className={classes.lightTheme}>
              <img
                ref={img}
                id="source"
                style={{ display: 'none' }}
                src={pic}
                alt="light profile"
              />
              <canvas
                ref={cnv}
                id="canvas"
                // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
                width={cp.width}
                // @ts-expect-error TS(2339): Property 'height' does not exist on type '{}'.
                height={cp.height}
                style={canvasStyle}
              />
            </Avatar>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <div className={classes.text}>LIGHT THEME</div>
          </div>
        </div>
        <FormHelperText className="api-text-error">{error}</FormHelperText>
      </DialogContent>
      <DialogActions style={{ display: 'block' }}>
        {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
        <div className={classes.buttonWrapper}>
          <div>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              type="file"
              ref={fileInputRef}
              onChange={changeImage}
            />
            <CbButton
              styleName="cancel"
              size="medium"
              onClick={selectFile}
              loading={loading}
              style={{ border: '1px solid #2180e2' }}
            >
              Change Image
            </CbButton>
          </div>

          <div>
            <CbButton styleName="cancel" size="small" onClick={closeModal}>
              Cancel
            </CbButton>
            <CbButton
              styleName="ctaButton"
              buttonText="Upload"
              loading={uploadLoading}
              onClick={onSubmit}
              size="small"
            />
          </div>
        </div>
      </DialogActions>
    </>
  );
};

export default UploadAgencyLogoSmall;
